/**
 * @fileoverview Orchestrate constants and defaults
 *
 * DEPRECATION IN POP 2.0
 * Along with removing ds-ui-foundation, 2.0 will replace lowercase keys
 * with ALL_CAPS_KEYS
 */

import { IvsApiConstants } from '@trp-dms-digital-shared/ds-ui-library-api';
import {
  TRP_DOMAINS,
  DADA_DOMAINS,
} from '@trp-dms-digital-shared/ds-ui-library-common';

import type { PopConfiguration } from '../../types.js';
// relative path to avoid bundling POP
// eslint-disable-next-line @nx/enforce-module-boundaries
import * as PopConstants from '../../../components/src/common/constants/index.js';

/**
 * Warning to console when installing Beacon via Orchestrate
 */
const LOG_BEACON_ORCHESTRATE_WARN = `Warning: DO NOT USE IN PRODUCTION.
Orchestrating Beacon via POP Orchestrate is for development only and will cause performance issues.
For Beacon proudction use, follow Beacon's docs:
${PopConstants.BEACON_DOCS_URL_CDN}
`;

export const Constants = {
  POP_CONFIGURATION: '_popConfiguration',
  DADA_ENDPOINT: 'dada-endpoint',
  DADA_APIKEY: 'dada-apikey',
  ASSETS_DOMAIN: 'assets-domain',
  PRODUCT_COMPONENT_LIBRARY_VERSION: 'product-component-library-version',
  IVS_ENDPOINT: 'ivs-endpoint',
  IVS_APIKEY: 'ivs-apikey',
  COUNTRY: 'country',
  LANGUAGE: 'language',
  AUSTRALIAN_COUNTRY_CODE: '/au/',
  BEACON_URL_ROOT_PATH: PopConstants.BEACON_URL_ROOT_PATH,
  BEACON_REGISTER_PATH: PopConstants.BEACON_REGISTER_PATH,
  BEACON_CSS_FILES: PopConstants.BEACON_CSS_FILES,
  POP_URL_ROOT_PATH: PopConstants.POP_URL_ROOT_PATH,
  POP_URL_ROOT_VERSIONED: PopConstants.POP_URL_ROOT_VERSIONED,
  LOG_IMPORT_BEACON_ERROR: 'Error importing Beacon CDN register.js: ',
  LOG_BEACON_ORCHESTRATE_WARN,
  LOG_POP_LOCAL_VERSION: 'Using local version of Product Component Library',
  LOG_POP_SKIP_REGISTER: 'Skipping POP components orchestration',
} as const;

export const Defaults = {
  ASSETS_DOMAIN: TRP_DOMAINS.DEV,
  COUNTRY: 'us',
  DADA_ENDPOINT: DADA_DOMAINS.DEV,
  DADA_APIKEY: 'Psc18DBJpbD3oIEZNSw8wodAYV3odpSebAHmGGL8ZezRKbaI',
  IVS_ENDPOINT: IvsApiConstants.ENDPOINT_DEV,
  IVS_APIKEY: 'lhiKZfzAAJX3bpABwQknSzBXSKic6OaC',
  DS_UI_LIBRARY_VERSION: 'latest',
  BEACON_VERSION: PopConstants.BEACON_DEFAULT_VERSION,
  BEACON_SKIP: true,
  POP_SKIP: false,
  LANGUAGE: 'en',
  PRODUCT_COMPONENT_LIBRARY_VERSION: 'latest',
  BEACON_PROJECT_NAME: '',
} as const;

/**
 * Default PopConfiguration object
 */
export const DefaultWindowConfig: PopConfiguration = {
  assetsDomain: Defaults.ASSETS_DOMAIN,
  dadaEndpoint: Defaults.DADA_ENDPOINT,
  dadaApiKey: Defaults.DADA_APIKEY,
  ivsEndpoint: Defaults.IVS_ENDPOINT,
  ivsApiKey: Defaults.IVS_APIKEY,
  dsUiLibraryVersion: Defaults.DS_UI_LIBRARY_VERSION,
  productComponentLibraryVersion: Defaults.PRODUCT_COMPONENT_LIBRARY_VERSION,
  beaconVersion: Defaults.BEACON_VERSION,
  beaconProjectName: Defaults.BEACON_PROJECT_NAME,
  beaconSkip: Defaults.BEACON_SKIP,
  popSkip: Defaults.POP_SKIP,
  country: Defaults.COUNTRY,
  language: Defaults.LANGUAGE,
};
